<button
    mat-icon-button
    (click)="_openSettings()"
    [tcTooltip]="'tableSettings.configColumns' | translate: _locale.language"
>
    <mat-icon fontIcon="icon-settings"></mat-icon>
</button>
